import {reactive} from "vue";

export default function () {
    const freeImages = reactive({
        'free_img_1' : require('@/assets/free_img_1.png'),
        'free_img_2' : require('@/assets/free_img_2.jpg'),
        'free_img_3' : require('@/assets/free_img_3.gif'),
        'free_img_4' : require('@/assets/free_img_4.png'),
        'free_img_5' : require('@/assets/free_img_5.png'),
        'free_video' : require('@/assets/free_video.mp4'),
        'free_video_vp9' : require('@/assets/free_video_vp9.webm'),
    })


    const freeImagesExcludeVp9 = reactive([
        { label: 'none', value: '' },
        { label: 'free_img_1', value: 'free_img_1.png' },
        { label: 'free_img_2', value: 'free_img_2.jpg' },
        { label: 'free_img_3', value: 'free_img_3.gif' },
        { label: 'free_img_4', value: 'free_img_4.png' },
        { label: 'free_img_5', value: 'free_img_5.png' },

    ])

    const bgImages = reactive([
        { label: 'none', value: '' },
        { label: 'free_img_1', value: 'free_img_1.png' },
        { label: 'free_img_2', value: 'free_img_2.jpg' },
        { label: 'free_img_3', value: 'free_img_3.gif' },
        { label: 'free_video_vp9', value: 'free_video_vp9.webm' },
    ])

    const bgImagesByRain3D = reactive([
        { label: 'none', value: '' },
        { label: 'free_img_1', value: 'free_img_1.png' },
        { label: 'free_img_2', value: 'free_img_2.jpg' }
    ])

    const watermarkImages = reactive([
        { label: 'free_img_4', value: 'free_img_4.png' },
        { label: 'free_img_5', value: 'free_img_5.png' }
    ])

    return {
        freeImages,
        freeImagesExcludeVp9,
        bgImages,
        bgImagesByRain3D,
        watermarkImages
    }
}
